import { jsx as _jsx } from "react/jsx-runtime";
import React, { useContext } from "react";
import PublicRoomContext from "../../../../application/Context/PublicRoomContext";
export var MessagesHeader = function () {
    var _a = useContext(PublicRoomContext), selectedChannel = _a.selectedChannel, channels = _a.channels;
    var channel = channels.filter(function (obj) { return obj.id === selectedChannel; });
    return (_jsx(React.Fragment, { children: _jsx("div", { className: "pr-header", children: _jsx("p", { className: "fw-bold", children: channel[0] && channel[0].name }) }) }));
};
